import i18next from 'i18next';
import * as yup from 'yup';

export const factoryYup = () => {
  yup.setLocale({
    mixed: {
      required: () => i18next.t('common.validations.fieldRequired')
    },
    string: {
      email: () => i18next.t('common.validations.email'),
      min: ({ min }) => i18next.t('common.validations.minStringValue', { min }),
      max: ({ max }) => i18next.t('common.validations.maxStringValue', { max })
    },
    number: {
      min: ({ min }) => i18next.t('common.validations.minNumberValue', { min }),
      max: ({ max }) => i18next.t('common.validations.maxNumberValue', { max })
    }
  });
  return yup;
};

export const limit = {
  maxPhoneNumberArea: 4,
  maxUserName: 50,
  maxName: 100,
  maxTranslable: 200,
  maxNameCatalog: 150,
  maxDescription: 100,
  maxEmail: 100,
  maxCode: 50,
  maxTemplate: 15000,
  minCode: 1,
  maxTexAdditionalField: 300
};

// yup.setLocale({
//   string: {
//     min: i18next.t('common.validations.minStringValue'),
//     max: i18next.t('common.validations.maxStringValue')
//   },
//   number: {
//     min: i18next.t('common.validations.minNumberValue'),
//     max: i18next.t('common.validations.maxNumberValue')
//   }
// });
//
// export default yup;
